import { Grid, InputLabel, Select } from "@mui/material";
import { GridFilterItem, GridFilterOperator } from "@mui/x-data-grid";
import { MenuItemStyled } from "../../../components/ui/rolesChip";
import UserRoles from "../../../constants/roles";

import { GlobeIcon } from "@phosphor-icons/react/dist/csr/Globe";
import { Pill } from "../../../components/ui/Pill";

interface FilterRolesComponentProps {
  item: GridFilterItem;
  applyValue: (value: GridFilterItem) => void;
}

const FilterRolesComponent = ({ item, applyValue }: FilterRolesComponentProps) => {
  return (
    <>
      <InputLabel id="roles-label">Roles</InputLabel>
      <Select
        data-testid="roles-select"
        variant="standard"
        value={item?.value || []}
        onChange={(event) =>
          applyValue({
            ...item,
            value: event.target.value,
          })
        }
        multiple
        renderValue={(roles: Array<keyof typeof UserRoles>) => {
          return (
            <Grid container spacing={1}>
              {roles.map((role) => {
                return (
                  <Grid key={role}>
                    <Pill
                      size="small"
                      label={UserRoles[role]?.value || "-"}
                      role={UserRoles[role]?.value}
                      data-cy={UserRoles[role]?.value}
                    />
                  </Grid>
                );
              })}
            </Grid>
          );
        }}
      >
        <MenuItemStyled key="-" value="-" data-testid="-">
          -
        </MenuItemStyled>
        {Object.values(UserRoles).map((role) => (
          <MenuItemStyled key={role.value} value={role.value} data-testid={role.value}>
            {role.label}
          </MenuItemStyled>
        ))}
      </Select>
    </>
  );
};
const getFilterRolesOperator = ({ rowField }: { rowField: string }) => {
  const filterRolesOperator: GridFilterOperator[] = [
    {
      label: "matches any",
      value: "matchesAny",
      getApplyFilterFn: (filterItem) => {
        const selectedRoles = filterItem.value || [];
        return (_, row) => {
          const userGlobalRoles = row[rowField];
          if (selectedRoles.length === 0) {
            return true;
          }
          if (userGlobalRoles.length === 0) {
            return selectedRoles.includes("-");
          }
          return userGlobalRoles.some((role: string) => selectedRoles.includes(role));
        };
      },
      InputComponent: FilterRolesComponent,
    },
    {
      label: "matches all",
      value: "matchesAll",
      getApplyFilterFn: (filterItem) => {
        const selectedRoles = (filterItem.value || []) as string[];
        return (_, row) => {
          if (selectedRoles.length === 0) {
            return true;
          }
          const userGlobalRoles = row[rowField] as string[];
          if (userGlobalRoles.length === 0) {
            return selectedRoles.every((role) => role === "-");
          }
          return (
            selectedRoles.every((role) => userGlobalRoles.includes(role)) &&
            selectedRoles.length === userGlobalRoles.length
          );
        };
      },
      InputComponent: FilterRolesComponent,
    },
  ];
  return filterRolesOperator;
};

const getRenderCell = ({ rowField }: { rowField: Array<keyof typeof UserRoles> }) => {
  const roles = rowField || [];
  if (roles.length > 0) {
    return (
      <Grid container spacing={1}>
        {roles.map((role) => {
          if (!role) console.error(`The role ${role} does not exist`);
          if (!(role in UserRoles)) console.error(`The role ${role} does not exist in USER_ROLES`);
          return (
            <Grid key={role}>
              <Pill
                role={UserRoles[role].value}
                label={UserRoles[role].label}
                icon={<GlobeIcon width="14px" height="14px" />}
              />
            </Grid>
          );
        })}
      </Grid>
    );
  }
  return "-";
};

export { getFilterRolesOperator, getRenderCell };
